import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BrainSkill = props => {
  return <FontAwesomeIcon icon="fa-solid fa-brain" />;
};

export default BrainSkill;
